import { render, staticRenderFns } from "./bocConfigure.vue?vue&type=template&id=90dea664&scoped=true"
import script from "./bocConfigure.vue?vue&type=script&lang=js"
export * from "./bocConfigure.vue?vue&type=script&lang=js"
import style0 from "./bocConfigure.vue?vue&type=style&index=0&id=90dea664&prod&scoped=true&lang=css"
import style1 from "./bocConfigure.vue?vue&type=style&index=1&id=90dea664&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90dea664",
  null
  
)

export default component.exports